import { Circle } from '@visx/shape';
import { scaleLinear } from '@visx/scale';
import { extent } from "d3-array";
import { Group } from "@visx/group";

const MiniEmbeddingsPlot = ({
    embeddingData,
    plotHeight,
    plotWidth,
    selectedEmbeddingIndex,
    marginForEachSide,
    shownQuestionIndices    
}) => {

    const xExtent = extent(embeddingData, d => d[0]);
    const xScale = scaleLinear({
        domain: xExtent,
        range: [0, plotWidth - (marginForEachSide * 2)],
    });

    const yExtent = extent(embeddingData, d => d[1]);
    const yScale = scaleLinear({
        domain: yExtent,
        range: [plotHeight - (marginForEachSide * 2), 0]
    });

    return (
        <Group
            top={marginForEachSide}
            left={marginForEachSide}
        >
            {
                embeddingData.length > 0 &&
                <>
                    {
                        embeddingData.map((point, i) => (
                            shownQuestionIndices.includes(i) &&
                            <Circle
                                key={`point-${i}`}
                                cx={xScale(point[0])}
                                cy={yScale(point[1])}
                                r='2'
                                strokeWidth={0}
                                opacity={i === selectedEmbeddingIndex ? 1 : 0.2}
                                fill={'black'}
                            />
                        ))
                    }
                </>
            }
        </Group>)
}

export default MiniEmbeddingsPlot;